import { useSWR } from '~/hooks/useSWR';

import { getPendingData } from './data';

export const useSchedulePendingEmployment = (employeeId: number) => {
  const { data, isLoading, error } = useSWR(
    ['schedulePendingEmployment', employeeId],
    () => getPendingData(employeeId),
    { revalidateOnFocus: false },
  );

  return {
    data: data || [],
    isLoading,
    error,
  };
};
